module.exports = __webpack_public_path__ + "img/block2Img02.9dac2bcb.png";